import { render, staticRenderFns } from "./card-model-print.vue?vue&type=template&id=0a321e50&"
import script from "./card-model-print.vue?vue&type=script&lang=js&"
export * from "./card-model-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports